import {api} from "./index";
import {Teacher, TeacherCreateRequest, TeacherUpdateRequest} from "../../shared/types/teacher";
import {PageRequest, PageResponse} from "../../shared/types/page";


export const createTeacherFetch = async (request: TeacherCreateRequest): Promise<Teacher> => {
  const response = await api.post<Teacher>(
      `/teachers`,
      request
  );
  return response.data;
};

export const updateTeacherFetch = async (
    id: number,
    request: TeacherUpdateRequest
): Promise<Teacher> => {
  const response = await api.patch<Teacher>(
      `/teachers/${id}`,
      request
  );
  return response.data;
};


export const switchTeacherStatusFetch = async (id: number): Promise<Teacher> => {
  const response = await api.post<Teacher>(
      `/teachers/${id}/switch/enabled`
  );
  return response.data;
};

export const loadCurrentTeacherFetch = async (): Promise<Teacher> => {
  const response = await api.get<Teacher>(
      `/teachers/current`
  );
  return response.data;
};


export const getAllTeachersFetch = async (
    pageRequest: PageRequest
): Promise<PageResponse<Teacher>> => {
  const response = await api.post<PageResponse<Teacher>>(
      `/teachers/paginate`,
      pageRequest
  );
  return response.data;
};

export const getTeacherByIdFetch = async (id: number): Promise<Teacher> => {
  const response = await api.get<Teacher>(
      `/teachers/${id}`
  );
  return response.data;
};
